const subheadingsData = {
  1: [
    {
      title: "About Me",
      content: (
        <>
          <p>
            Hello, I'm Everson a beginner frontend and mobile developer, eager
            to learn more and create engaging user experiences. Passionate about
            coding, designing and creating innovative apps. Committed to
            continued growth and ready to embark on an exciting coding journey.
          </p>
        </>
      ),
    },
  ],
  2: [
    {
      title: "2020 The Beginning of a Dream",
      content: (
        <>
          <p>
            At the end of that year, I embarked on a self-taught journey to
            become a developer. It has been years of study, headaches, personal
            achievements, and numerous moments of giving up. However, the
            determination to succeed prevailed, and I'm still in the battle to
            keep learning and growing.
          </p>
        </>
      ),
    },
    {
      title: "2017 IFC - Araquari Campus",
      content: (
        <>
          <p>
            I started my education in Computer Network Technology at the Federal
            Institute of Santa Catarina - IFC. However, upon discovering
            Programming, I decided to leave college and dedicated myself to
            self-learning Frontend and Mobile Development.
          </p>
        </>
      ),
    },
  ],
  3: [
    {
      title: "2022 FrontEnd/Mobile Developer",
      content: (
        <>
          <p>
            I started my journey as a freelancer, doing small projects, mainly
            in mobile development using React Native. These experiences have
            been instrumental in honing and improving my skills. I eagerly
            anticipate delving deeper into cutting-edge technologies, pushing
            the boundaries of this ever-evolving field, and creating innovative
            solutions.
          </p>
        </>
      ),
    },
    {
      title: "2021 WordPress Developer",
      content: (
        <>
          <p>
            I founded a marketing agency specializing in crafting websites and
            landing pages for small local businesses. Though I had a few
            clients, the experience gained was invaluable.
          </p>
        </>
      ),
    },
  ],
};

export default subheadingsData;
